import { render } from "./ReplyContentComponent.vue?vue&type=template&id=5d880614&scoped=true"
import script from "./ReplyContentComponent.vue?vue&type=script&lang=js"
export * from "./ReplyContentComponent.vue?vue&type=script&lang=js"

import "./ReplyContentComponent.vue?vue&type=style&index=0&id=5d880614&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d880614"]])

export default __exports__